<template>
  <el-dialog
    title="风控记录"
    width="90vw"
    :visible="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="() => $emit('close')"
  >
    <table-render
      :config="config"
      :prop-data="{
        query: { projectId: projectId }
      }"
      :beforeInitPage="beforeInitPage"
    ></table-render>
  </el-dialog>
</template>

<script>
import TableRender from '../../../components/tableRender';
import { getStorage } from '../../../tools/storage';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { riskControl } from '../../../api/ajax';
import dateFormat from '../../../tools/dateFormat';
import createExtend from '../../../components/createExtend';
import digitalSurveyDetail from './digitalSurveyDetail';
import { mapState } from 'vuex';

let example = new TableRenderClass();

let part = example.createPart({
  name: '任务记录列表',
  list: riskControl.digitalSurvey.list,
  requestNow: true,
  fields: [
    {
      width: '200px',
      label: '修改时间',
      type: 'updateTime',
      formatter: a => {
        return dateFormat(a.updateTime);
      }
    },
    {
      width: '200px',
      label: '生效时间',
      type: 'enableDt',
      formatter: a => {
        return dateFormat(a.enableDt);
      }
    },
    {
      width: '200px',
      label: '修改人',
      type: 'username',
      formatter: a => {
        return a.username;
      }
    },
    {
      label: '修改记录',
      render: function(h, ctx, r) {
        const detail = () => {
          createExtend(digitalSurveyDetail, {
            row: r
          });
        };
        return (
          <el-button type="text" onClick={detail}>
            查看
          </el-button>
        );
      }
    }
  ]
});

export default {
  name: 'digitalSurveyRecord',
  components: { TableRender },
  props: {},
  data() {
    return {
      config: [{ name: '任务记录列表', childMenu: [part] }]
    };
  },
  computed: {
    ...mapState({
      projectInfo: state => state.homeProject,
      answerMode: state => state.homeProject.answerMode, // 1 自答 2 分享
      projectId: state => state.homeProject.id
    })
  },
  methods: {
    beforeInitPage({ respond }) {
      let list = respond.list;
      let userInfo = getStorage('user');
      respond.list = list.map(i => {
        return {
          ...i,
          username: userInfo.userName
        };
      });
      return respond;
    }
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
